import React from 'react';
import { Box } from '@mui/material';
import { Base, Win01, Win02 } from '../../../assets/images/tournamentLineFinal';

/**
 * TournamentLineFinal Component
 * @param {Object} props
 * @param {string} props.prop - 상태: "base" | "win 01" | "win 02"
 * @param {Object} props.sx - 추가 스타일
 * @param {Object} props...props - 기타 props
 */
export const TournamentLineFinal = ({ prop = "base", sx = {}, ...props }) => {
    const containerStyles = {
        position: 'relative',
        width: '100%',
        height: '100%',
        ...sx
    };

    // win 01 상태
    if (prop === "win 01") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.85%',
                    left: 0,
                    right: 0,
                    top: '1.85%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-1.92%',
                        left: 0,
                        right: 0,
                        top: '-1.92%'
                    }}>
                        <Win01
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    // win 02 상태
    if (prop === "win 02") {
        return (
            <Box sx={containerStyles} {...props}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '1.85%',
                    left: 0,
                    right: 0,
                    top: '1.85%'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        bottom: '-1.92%',
                        left: 0,
                        right: 0,
                        top: '-1.92%'
                    }}>
                        <Win02
                            style={{ width: '100%', height: '100%', display: 'block' }}
                        />
                    </Box>
                </Box>
            </Box>
        );
    }

    // 기본 상태 (base)
    return (
        <Box sx={containerStyles} {...props}>
            <Box sx={{
                position: 'absolute',
                bottom: '1.85%',
                left: 0,
                right: 0,
                top: '1.85%'
            }}>
                <Box sx={{
                    position: 'absolute',
                    bottom: '-1.92%',
                    left: 0,
                    right: 0,
                    top: '-1.92%'
                }}>
                    <Base
                        style={{ width: '100%', height: '100%', display: 'block' }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TournamentLineFinal;
